"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function LegalholdGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M1 13.777a1 1 0 011-1h6.061a1 1 0 011 1V15a1 1 0 01-1 1H2a1 1 0 01-1-1v-1.223z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    fillRule: "evenodd",
    d: "M13.426 12.381c.418.419.941.564 1.36.146l.638-.639c.418-.418.314-1.001-.104-1.42l-3.698-3.697L9.72 8.674l3.707 3.707zm-2.159-5.965l.002.001-2.28 2.28a.25.25 0 00-.043.057l-1.862 1.853a1.071 1.071 0 01-1.515 0L3.211 8.25a1.072 1.072 0 010-1.515L4.79 5.156a.25.25 0 00.066-.047l2.761-2.766a.25.25 0 00.043-.057L9.63.314a1.072 1.072 0 011.516 0l2.357 2.358a1.071 1.071 0 010 1.515l-2.237 2.229zM7.152 2.1l-.554-.554a1.072 1.072 0 00-1.516 0l-.638.638a1.072 1.072 0 000 1.515L5 4.256l2.152-2.155z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "orion-icon-legalhold-green-multitone-filled-a",
    style: {
      maskType: 'alpha'
    },
    width: 14,
    height: 13,
    x: 2,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M13.426 12.381c.418.419.941.564 1.36.146l.638-.639c.418-.418.314-1.001-.104-1.42l-4.053-4.052 2.238-2.229a1.071 1.071 0 000-1.515L11.146.314a1.072 1.072 0 00-1.516 0L7.498 2.447l-.9-.9a1.072 1.072 0 00-1.516 0l-.638.638a1.072 1.072 0 000 1.515l.9.9-2.133 2.134a1.072 1.072 0 000 1.515l2.358 2.358a1.071 1.071 0 001.515 0l2.29-2.278 4.052 4.052z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#orion-icon-legalhold-green-multitone-filled-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.106 5.934a.25.25 0 010 .353L9.342 9.051a.25.25 0 11-.353-.354l2.763-2.763a.25.25 0 01.354 0zM7.616 1.99a.25.25 0 010 .353L4.855 5.109a.25.25 0 01-.354-.354L7.263 1.99a.25.25 0 01.353 0zM3.645 5.752a.5.5 0 01.707.01l3.746 3.851a.5.5 0 11-.717.697L3.635 6.46a.5.5 0 01.01-.707zM8.713.444a.5.5 0 01.707.01l3.746 3.852a.5.5 0 11-.716.697L8.704 1.152a.5.5 0 01.01-.708z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 14.626,
    cy: 11.666,
    r: 1.314,
    fill: "#FF730E"
  }));
}

LegalholdGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
LegalholdGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = LegalholdGreenMultitoneFilled;
exports["default"] = _default;